import { EntityReference } from './EntityReference';
import { GUID } from './Guid';
import * as Collections from 'typescript-collections';

export abstract class BaseEntity {
    _attributeValues: Collections.Dictionary<string, any>;
    _primaryField: string;
    _id: GUID;
    _createdOn: Date;
    _createdBy: EntityReference;
    _modifiedOn: Date;
    _modifiedBy: EntityReference;

    constructor(primaryField: string) {
        this._primaryField = primaryField;
        this._attributeValues = new Collections.Dictionary<string, any>();
    }

    get id(): GUID {
        return this._id;
    }
    set id(val: GUID) {
        this._id = val;
        this[this._primaryField] = this._id;
        this._attributeValues['id'] = this._id;
    }

    get createdOn(): Date {
        return this._createdOn;
    }
    set createdOn(val: Date) {
        this._createdOn = val;
        this._attributeValues['createdOn'] = this._createdOn;
    }

    get createdBy(): EntityReference {
        return this._createdBy;
    }
    set createdBy(val: EntityReference) {
        this._createdBy = val;
        this._attributeValues['createdBy'] = this._createdBy;
    }

    get modifiedOn(): Date {
        return this._modifiedOn;
    }
    set modifiedOn(val: Date) {
        this._modifiedOn = val;
        this._attributeValues['modifiedOn'] = this._modifiedOn;
    }

    get modifiedBy(): EntityReference {
        return this._modifiedBy;
    }
    set modifiedBy(val: EntityReference) {
        this._modifiedBy = val;
        this._attributeValues['modifiedBy'] = this._modifiedBy;
    }

    get attributeValues(): Collections.Dictionary<string, any> {
        return this._attributeValues;
    }
    set attributeValues(val: Collections.Dictionary<string, any>) {
        this._attributeValues = val;
    }
}




// WEBPACK FOOTER //
// ./src/app/schemas/codegen/base/BaseEntity.ts